import moment from "jalali-moment";

function jalaliTime(enDate) {
  const date = moment(enDate).format("jYYYY/jMM/jDD");
  const time = moment(enDate).format("HH:mm:ss");
  return {
    date,
    time,
    full: date + "\n" + time,
  };
}

export default jalaliTime;
